module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "photoCell",
    staticClass: "photo-cell col-6 col-md-6 col-lg-3",
    style: ({
      height: _vm.photoCellHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "photo-cell-inner h-100 p-1",
    class: {
      favorite: _vm.input.isBuyTarget
    }
  }, [_c('div', {
    staticClass: "row no-gutters h-100"
  }, [_c('div', {
    staticClass: "col flex-grow-1 text-center h-100"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.smallThumbnailUrl),
      expression: "smallThumbnailUrl",
      arg: "background-image"
    }],
    staticClass: "photo-image contain",
    staticStyle: {
      "background-position": "bottom"
    },
    on: {
      "click": _vm.showPhotoImageModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-auto text-center h-100",
    staticStyle: {
      "padding-left": "1px"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column h-100 cart-photo-operation"
  }, [_c('div', {
    staticClass: "photo-no text-center mb-auto"
  }, [_vm._v(_vm._s(_vm.photo.photo_no))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "price-info"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['91'][3]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "size-info d-inline-block px-1"
  }, [_vm._v(_vm._s(_vm.photoSizeMark))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e76d9f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/Order/Confirm/SnapVerticalPhoto.vue
// module id = 702
// module chunks = 0